import { useDebouncedValue } from "@mantine/hooks"
import {
  useCreateUpdateRouteAssignmentMutation,
  useSurveyAreaVendorsLazyQuery,
} from "generated/graphql"
import useRouteStore from "pages/fsm/routes.store"
import { useCallback, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import { ROUTE_ASSIGNMENT_DETAIL } from "./routes.queries.gql"

export const useFetchSurveyAreaVendors = fetchData => {
  const [params] = useSearchParams()
  const [search] = useDebouncedValue(params.get("search"), 500)
  const setData = useRouteStore(store => store.setData)
  const surveyAreaId = useRouteStore(store => store.data.surveyArea?.id)

  const [fetch, response] = useSurveyAreaVendorsLazyQuery({
    variables: {
      surveyAreaId: surveyAreaId,
      first: 15,
      query: search,
    },
    onCompleted({ allVendorsBySurveyAreas }) {
      setData("outlets", allVendorsBySurveyAreas)
    },
  })
  const allOutlets = useRouteStore(
    useCallback(store => store.allOutlets(search), [search])
  )

  useEffect(() => {
    if (surveyAreaId && fetchData) {
      fetch()
    }
  }, [fetch, surveyAreaId, fetchData])

  // const searchRegex = useMemo(() => new RegExp(search, "gi"), [search])
  // const filteredOutlets = sortedOutlets.filter(
  //   outlet =>
  //     searchRegex.test(outlet.fullName) || searchRegex.test(outlet.number)
  // )

  return { response, allOutlets }
}

export const useRouteAssignmentUpdate = () => {
  const store = useRouteStore()
  const navigate = useNavigate()
  const [update] = useCreateUpdateRouteAssignmentMutation({
    onError({ message }) {
      AppToaster.show({ message, intent: "danger" })
    },
    onCompleted() {
      AppToaster.show({
        message: `Outlets assigned successfully!`,
        intent: "success",
        icon: "tick",
      })
      store.reset()
      navigate("/d/fsm/beat")
    },
    refetchQueries: [
      {
        query: ROUTE_ASSIGNMENT_DETAIL,
        variables: {
          id: store.data.id,
        },
      },
    ],
  })

  function updateRouteAssignment() {}
  return [update, updateRouteAssignment] as any
}
